import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mbCarouselItem]',
  standalone: true,
})
export class MbCarouselItemDirective<T> {
  constructor(public template: TemplateRef<T>) {}
}
